import { useQuery } from '@tanstack/react-query'
import { getClientUpdateNotifications } from '../../../../apis/clientUpdateNotification'
import { queryKeys } from '../../../../shared'

/**
 * クライアント更新通知 Query hook
 *
 * メインページでのみ通知を取得する。
 * 一度取得したらキャッシュを永続化（staleTime: Infinity）。
 *
 * @param enabled - 取得を有効にするかどうか（メインページ判定）
 */
export const useClientUpdateNotificationsQuery = (enabled: boolean) => {
  return useQuery({
    queryKey: queryKeys.notifications.clientUpdate(),
    queryFn: getClientUpdateNotifications,
    enabled,
    staleTime: Infinity, // 1回のみ取得
    retry: false,
  })
}
